import { Col, Form, Offcanvas, Row } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { IAspectoEvaluar } from "../../../entities/IInspeccionObservacion";
import React, { useRef, useState } from "react";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import { cognitoUserInfo } from "../../../helpers/userHelper";
import ICurrentUser from "../../../entities/helper/ICurrentUser";
import { dateFormatInputReference, shortDate } from "../../../helpers/dateHelper";
import IDocumentoLIO, { IDocumentoLIOAspectoEvaluar } from "../../../entities/IDocumentoLIO";
import moment from "moment";
import { EnumTipoDocumentoAuditoria } from "../../../entities/helper/EnumTipoDocumentoAuditoria";
import LIOService from "../../../services/LIOService";
import { AdminListaPagination, IPagination } from "../../../controls/AdminListaPagination";
import { ROW_COUNT } from "../../../helpers/variableHelper";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { getFileName } from "../../../helpers/pathHelper";
import { ITipo_Campo } from "../../../helpers/IFormHelper";
import DesviacionService from "../../../services/DesviacionService";
import Loading from "../../../cross/Loading";
import { ISetAspectoEvaluar } from "../../../entities/IInspeccionAspectoEvaluar";
import RenderTitle from "../../../controls/RenderTitle";
import RenderValue from "../../../controls/RenderValue";

const MySwal = withReactContent(Swal);

interface IAspectoEvaluarProps {
  token: string;
  idLIO: number;
  onClose: () => void;
  aspecto: IAspectoEvaluar | null;
  readonly: boolean;
  items?: Array<any>;
}
export default function RealizarAccionAspecto({ token, idLIO, onClose, aspecto, readonly, items }: IAspectoEvaluarProps) {
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const totalPageListDocumentos = useRef<number>(0);
  const refTxtAccionRealizada = React.createRef<HTMLTextAreaElement>();
  const [arrErrorEmpty, setArrErrorEmpty] = useState<Array<string>>([]);
  const [lenAccionRealizada, setLenAccionRealizada] = useState(0);
  const [fechaAccionRealizada, setFechaAccionRealizada] = useState<string>();
  const refTxtDescripcionDocumento = React.createRef<HTMLTextAreaElement>();
  const [lenDescripcionDoc, setLenDescripcionDoc] = useState(0);
  const refInputFile = React.createRef<HTMLInputElement>();
  const [documentosLIOAspectoAsignado, setDocumentosLIOAspectoAsignado] = useState<IDocumentoLIOAspectoEvaluar[]>(items || []);
  const [arrErrorEmptyFile, setArrErrorEmptyFile] = useState<Array<string>>([]);
  const [isUploadingDoc, setIsUploadingDoc] = useState(false);
  const [isSendingData, setIsSendingData] = useState(false);
  console.log(arrErrorEmptyFile);

  usePromiseEffect(async () => {
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);
    console.log("aspecto", aspecto);
    if (idLIO) {
      setFechaAccionRealizada(moment(aspecto?.FECHA_ACCIONAR).format("yyyy-MM-DD") || "");
    }
  }, []);

  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const renderAccionRealizada = () => {
    if (isSendingData) {
      return <Loading />;
    } else {
      return (
        <span>
          <button
            className="btn btn-sm btn-primary me-2"
            onClick={() => {
              handleAccion(false);
            }}
            disabled={isSendingData}>
            Guardar
          </button>
          <button
            className="btn btn-sm btn-primary me-2"
            onClick={() => {
              handleAccion(true);
            }}
            disabled={isSendingData}>
            Acción Realizada
          </button>
        </span>
      );
    }
  };

  const componentVer = (info: any) => {
    return (
      <div>
        <i
          className="bi bi-search iconSearch"
          title="Ver Documento"
          onClick={() => {
            DesviacionService.getContenidoArchivo(token, info.row.original.URL);
          }}></i>
      </div>
    );
  };

  const componentEliminar = (info: any) => {
    return (
      <div>
        {info.row.original.ID != null ? (
          <i
            className="bi bi-trash iconTrash"
            title="Eliminar Documento"
            onClick={() => {
              MySwal.fire({
                html: (
                  <div>
                    <h3>¿Desea eliminar el documento {getFileName(info.row.original.URL)}?</h3>
                  </div>
                ),
                text: "",
                icon: "question",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
                showCloseButton: true,
                showCancelButton: true,
              }).then(async (result) => {
                if (result.isConfirmed) {
                  await LIOService.deleteDocumentoLIOAspectoEvaluar(token, info.getValue());

                  await refreshDocuments(null);
                }
              });
            }}></i>
        ) : (
          <React.Fragment />
        )}
      </div>
    );
  };

  const validateUploadFile = (value: Partial<IDocumentoLIO>) => {
    let arrErrors: Array<string> = [];

    if (!refInputFile.current?.files) {
      arrErrors.push("ARCHIVO");
    } else {
      if (documentosLIOAspectoAsignado.filter((l) => l.URL.includes((refInputFile.current?.files as FileList)[0].name)).length > 0) {
        arrErrors.push("ARCHIVO_DUPLICADO");

        MySwal.fire({
          html: (
            <div>
              <h3>Archivo "{(refInputFile.current?.files)[0].name}" ya se encuentra cargado</h3>
            </div>
          ),
          text: "",
          icon: "error",
          showCloseButton: true,
        });
      }
    }
    setArrErrorEmptyFile(arrErrors);
    return arrErrors.length === 0;
  };

  const refreshDocuments = async (pagination?: IPagination | null) => {
    const defaultPagination: IPagination = pagination || {
      ORDENADOPOR: "ID",
      ORIENTACION: "ASC",
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
    };
    if (aspecto?.ID) {
      let result = await LIOService.getDocumentosLIOAspectoEvaluar(token, {
        ...defaultPagination,
        ID_TIPO_DOCUMENTO: EnumTipoDocumentoAuditoria.AspectoAsignado,
        ID_LIO_INSPECCION_OBSERVACION: idLIO,
        ID_LIO_ASPECTO_EVALUAR: aspecto?.ID,
      });
      totalPageListDocumentos.current = result.pages;
      setDocumentosLIOAspectoAsignado(result.data);
    }
  };

  const handleGuardarDocumento = async () => {
    let f = (refInputFile.current?.files as FileList)[0] as any;
    let value: Partial<IDocumentoLIOAspectoEvaluar> = {
      ID_TIPO_DOCUMENTO: EnumTipoDocumentoAuditoria.AspectoAsignado,
      ID_LIO_INSPECCION_OBSERVACION: idLIO,
      ID_LIO_ASPECTO_EVALUAR: aspecto?.ID as number,
      // URL: null,
      DESCRIPCION: refTxtDescripcionDocumento.current?.value,
      FILE: f,
    };
    if (validateUploadFile(value)) {
      setIsUploadingDoc(true);
      if (aspecto?.ID != null) {
        value.ID_LIO_INSPECCION_OBSERVACION = idLIO;
        await LIOService.addDocumentosLIOAspectoEvaluar(token, value);
        await refreshDocuments();
        //Limpiar
        setLenDescripcionDoc(0);
        setIsUploadingDoc(false);
      }
    }
  };

  const formValidation = (value: ISetAspectoEvaluar) => {
    let arrErrors: Array<string> = [];

    if (!value.ACCION_REALIZADA) {
      arrErrors.push("ACCION_REALIZADA");
    }

    if (!moment(value.FECHA_ACCION_REALIZADA).isValid()) {
      arrErrors.push("FECHA_ACCION_REALIZADA");
    }
    if (value.MARCAR_ACCION_REALIZADA && documentosLIOAspectoAsignado.length == 0) {
      arrErrors.push("EVIDENCIAS");
      MySwal.fire({
        html: (
          <div>
            <h3>Debe adjuntar evidencia</h3>
          </div>
        ),
        text: "",
        icon: "error",
        showCloseButton: true,
      });
    }

    setArrErrorEmpty(arrErrors);
    return arrErrors.length === 0;
  };

  const handleAccion = async (marcarAccionRealizada: boolean) => {
    let value: ISetAspectoEvaluar = {
      ID: aspecto?.ID as number,
      ID_INSPECCION_OBSERVACION: aspecto?.ID_INSPECCION_OBSERVACION as number,
      ID_ESTADO: aspecto?.ID_ESTADO,
      FECHA_ACCION_REALIZADA: new Date(fechaAccionRealizada as string),
      ACCION_REALIZADA: refTxtAccionRealizada.current?.value as string,
      MARCAR_ACCION_REALIZADA: marcarAccionRealizada,
      ACCION_REALIZADA_POR: marcarAccionRealizada ? currentUser?.email : null,
      ACCION_REALIZADA_POR_DISPLAY: marcarAccionRealizada ? currentUser?.fullname : null,
      FECHA_MODIFICACION: new Date(),
      EDITOR: currentUser?.fullname,
      EDITOR_DISPLAY: currentUser?.fullname,
    };

    console.log(value);
    if (formValidation(value)) {
      if (refInputFile.current?.files) {
        console.log("");
      }
      setIsSendingData(true);
      let id = await LIOService.setAspectoEvaluarAccionAsignada(token, value);
      setIsSendingData(false);
      onClose();
      return id;
    } else {
      return -1;
    }
  };

  const columnHelperLIODocumentos = createColumnHelper<IDocumentoLIO>();
  let columnsDefLIODocumentos = [
    columnHelperLIODocumentos.accessor((row) => row.URL, {
      id: "URL",
      cell: (info: CellContext<IDocumentoLIO, string>) => componentValue(getFileName(info.getValue())),
      header: () => component("Nombre Documento"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperLIODocumentos.accessor((row) => "Ingreso Lista", {
      id: "CATEGORIA",
      cell: (info: CellContext<IDocumentoLIO, string>) => componentValue("Ingreso Lista"),
      header: () => component("Categoría"),
      tipo: ITipo_Campo.text,
      hide: true,
    } as any),
    columnHelperLIODocumentos.accessor((row) => row.DESCRIPCION, {
      id: "DESCRIPCION",
      cell: (info: CellContext<IDocumentoLIO, string>) => componentValue(info.getValue()),
      header: () => component("Descripción"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperLIODocumentos.accessor((row) => row.ID, {
      id: "ACCIONES",
      cell: (info: CellContext<IDocumentoLIO, string>) => componentVer(info),
      header: () => component("Ver"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
    columnHelperLIODocumentos.accessor((row) => row.ID, {
      id: "ACCIONES_ELIMINAR",
      cell: (info: CellContext<IDocumentoLIO, number>) => componentEliminar(info),
      header: () => component("Eliminar"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
  ] as any;

  return (
    <Offcanvas show={true} onHide={onClose} placement={"end"} className="w-50 modalAgregarCausa">
      <Offcanvas.Header closeButton className="border-bottom">
        <Offcanvas.Title className="m-3 mb-1 colorTit">{aspecto?.NUEVO_FORMATO_FAENA ? "Acción" : "Aspecto"}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="m-3">
        <Row>
          <Col>
            <div className="row mb-2 ajusteInput">
              <Col xs="12" md="6" lg="4">
                <label>{aspecto?.NUEVO_FORMATO_FAENA ? "N° Acción:" : "N° Aspecto:"}</label>
              </Col>
              <Col xs="12" md="6" lg="8">
                <span>{aspecto?.TITULO}</span>
              </Col>
            </div>
            <div className="row mb-2 ajusteInput">
              <Col xs="12" md="6" lg="4">
                <label>Fecha Asignación:</label>
              </Col>
              <Col xs="12" md="6" lg="8">
                <span>{shortDate(aspecto?.FECHA_ASIGNACION)}</span>
              </Col>
            </div>

            <div className="row mb-2 ajusteInput">
              <Col xs="12" md="6" lg="4">
                <label>Fecha Hasta:</label>
              </Col>
              <Col xs="12" md="6" lg="8">
                <span>{shortDate(aspecto?.FECHA_HASTA)}</span>
              </Col>
            </div>

            <div className="row mb-2 ajusteInput">
              <Col xs="12" md="6" lg="4">
                <label>Acción Realizada:</label>
              </Col>
              <Col xs="12" md="6" lg="8">
                <span>
                  <textarea
                    data-testid="test1"
                    className={`form-control form-control-sm ${arrErrorEmpty.includes("ACCION_REALIZADA") && "error"}`}
                    rows={3}
                    ref={refTxtAccionRealizada}
                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setLenAccionRealizada(e.target.value.length)}
                    maxLength={250}
                    defaultValue={aspecto?.ACCION_REALIZADA || ""}
                    disabled={readonly}></textarea>
                  <span>{lenAccionRealizada}/250</span>
                </span>
              </Col>
            </div>
          </Col>
          <Col>
            <div className="row mb-2 ajusteInput">
              <Col xs="12" md="6" lg="4">
                <label>{aspecto?.NUEVO_FORMATO_FAENA ? "Nombre Acción:" : "Nombre Aspecto:"}</label>
              </Col>
              <Col xs="12" md="6" lg="8">
                <span>{aspecto?.NOMBRE_ELEMENTO}</span>
              </Col>
            </div>
            <div className="row mb-2 ajusteInput">
              <Col xs="12" md="6" lg="4">
                <label>Responsable Acción:</label>
              </Col>
              <Col xs="12" md="6" lg="8">
                <span>{aspecto?.RESPONSABLE_DISPLAY}</span>
              </Col>
            </div>
            {!aspecto?.NUEVO_FORMATO_FAENA && (
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="4">
                  <label>Acción a Realizar:</label>
                </Col>
                <Col xs="12" md="6" lg="8">
                  <span>{aspecto?.OBSERVACION}</span>
                </Col>
              </div>
            )}
            <div className="row mb-2 ajusteInput">
              <Col xs="12" md="6" lg="4">
                <label>Fecha Acción Realizada:</label>
              </Col>
              <Col xs="12" md="6" lg="8">
                <Form.Control
                  onChange={(e) => {
                    setFechaAccionRealizada(e.target.value);
                  }}
                  data-testid="test3"
                  type="date"
                  defaultValue={aspecto?.FECHA_ACCIONAR ? moment(aspecto?.FECHA_ACCIONAR).format("yyyy-MM-DD") : fechaAccionRealizada}
                  className={`${arrErrorEmpty.includes("FECHA_ACCION_REALIZADA") && "error"}`}
                  max={moment().format(dateFormatInputReference)}
                  disabled={readonly}
                />
              </Col>
            </div>
          </Col>
        </Row>
        <div className="col-sm-12 col-md-12 col-lg-12 mb-2">
          <h5 className="titPaneles">Evidencias</h5>
        </div>

        {!isUploadingDoc && !readonly && (
          <div className="row border m-1 p-1 rounded">
            <div className="col-sm-12 col-md-12 col-lg-2 mb-2">
              <label>Descripción</label>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-10 mb-2">
              <textarea
                className="form-control form-control-sm"
                rows={3}
                data-testid="test2"
                ref={refTxtDescripcionDocumento}
                onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setLenDescripcionDoc(e.target.value.length)}
                maxLength={250}></textarea>
              <span>{lenDescripcionDoc}/250</span>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-2 mb-2">
              <label>Adjuntar </label>
              <span className="text-danger">
                <small> Peso maximo (50 mb).</small>
              </span>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-10 mb-2">
              <div className="input-group">
                <input
                  type="file"
                  className="form-control form-control-sm"
                  id="inputGroupFile04"
                  aria-describedby="inputGroupFileAddon04"
                  aria-label="Seleccionar Archivos"
                  ref={refInputFile}
                />
                <button
                  className="btn btn-primary btn-sm"
                  type="button"
                  id="inputGroupFileAddon04"
                  onClick={() => {
                    handleGuardarDocumento();
                  }}>
                  Subir
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="row mb-2 ajusteInput">
          <AdminListaPagination
            defaultSortBy="ID"
            sortDirection="DESC"
            totalPages={totalPageListDocumentos}
            resultPerPage={ROW_COUNT}
            callback={(pagination) => {
              refreshDocuments(pagination);
            }}
            data={documentosLIOAspectoAsignado}
            reload={() => {
              refreshDocuments();
            }}
            columnsDef={columnsDefLIODocumentos}
            hideAdd={true}
            hideExport={true}
          />
        </div>
        <div className="container-fluid mb-4">
          <div className="card bg-light border p-3 pt-2 mt-2">
            <div className="row mb-2 ajusteInput mt-4">
              <Col xs="4" md="4" lg="4"></Col>
              <Col xs="4" md="4" lg="4" className="text-center">
                {!readonly ? ( //
                  renderAccionRealizada()
                ) : (
                  <></>
                )}
                <button
                  className="btn btn-sm btn-primary me-2"
                  onClick={() => {
                    window.location.href = "/lio";
                  }}
                  disabled={isSendingData}>
                  Volver
                </button>
              </Col>
              <Col xs="4" md="4" lg="4"></Col>
            </div>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}
